import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MW_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#MW_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E11C1B"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "MW_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#MW_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0v10h32V0H0z", fill: "#272727" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#5EAA22" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.001 11.945v-.002l-.009.002h.01zm.628-3.819h.101l-.155-.024.054.024zm2.928 0c.053-.1.107-.2.164-.298L5.432 6.312l2.7.879c.151-.212.313-.416.485-.614l-1.984-1.89 2.529 1.32a8.9 8.9 0 01.582-.51L8.14 3.282l2.266 1.734c.211-.14.429-.273.653-.398l-1.155-2.48 1.914 2.101c.228-.102.462-.196.7-.282l-.65-2.664 1.482 2.404c.24-.064.482-.12.728-.167L13.97.774l.987 2.624c.243-.026.49-.045.738-.054L16.141.6l.447 2.744c.248.01.494.03.737.056l.987-2.626-.109 2.76c.246.047.488.103.725.167l1.486-2.409-.653 2.671c.237.086.47.18.696.282l1.921-2.108-1.16 2.49c.222.124.439.256.648.395l2.276-1.741-1.613 2.227c.201.162.393.33.577.506l2.543-1.326-1.996 1.9c.17.196.33.399.48.608l2.717-.884-2.305 1.526c.055.095.108.19.158.288h-1.965c-1.354-1.877-3.829-3.133-6.657-3.133-2.829 0-5.303 1.256-6.657 3.133H7.557zm3.002 0c1.283-1.323 3.298-2.176 5.563-2.176 2.265 0 4.279.853 5.562 2.176H10.559zm16.992 0h.102l.053-.024-.154.024zm.73 3.817l.008.002h-.008v-.002z",
      fill: "#E11C1B"
    }
  )))
), a = t;
export {
  a as default
};
